export const GET_OFFICES_REQUEST = "GET_OFFICES_REQUEST"
export const GET_OFFICES_REQUEST_SUCCESS = "GET_OFFICES_REQUEST_SUCCESS"

export const GET_OFFICE_REQUEST = "GET_OFFICE_REQUEST"
export const GET_OFFICE_REQUEST_SUCCESS = "GET_OFFICE_REQUEST_SUCCESS"

export const UPDATE_OFFICES_REQUEST = "UPDATE_OFFICES_REQUEST"
export const UPDATE_OFFICES_REQUEST_SUCCESS = "UPDATE_OFFICES_REQUEST_SUCCESS"
